import { useState, useMemo } from 'react';
import { Box, Heading, Button, Flex, Text } from 'rebass';

const JsonPrettifier = ({ night, setNight }) => {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  const pretty = useMemo(() => {
    if (!input.trim()) {
      setError('');
      return '';
    }
    try {
      const parsed = JSON.parse(input);
      setError('');
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      setError(e.message);
      return '';
    }
  }, [input]);

  const usePrettyAsEditable = () => {
    if (pretty) setInput(pretty);
  };

  return (
    <Box maxWidth="800px" mx="auto" py={4} px={[3, 4]}> 
      <Heading as="h1" mb={3} fontFamily="Menlo, ui-monospace, monospace" color={night ? '#f5f5f5' : '#222'}>
        JSON Prettifier
      </Heading>
      <Text mb={3} fontFamily="Menlo, ui-monospace, monospace" color="gray">
        Paste your JSON on the left. Prettified output appears on the right. You can also make the prettified JSON editable.
      </Text>
      <Flex flexDirection={["column", "row"]} gap={3}>
        <Box width={["100%", 1/2]} mb={[3, 0]}>
          <Box
            as="textarea"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            rows={20}
            sx={{
              width: '100%',
              fontFamily: 'Menlo, ui-monospace, monospace',
              fontSize: 1,
              backgroundColor: night ? '#1e1e1e' : '#fafafa',
              color: night ? '#f5f5f5' : '#222',
              borderColor: night ? '#333' : '#ddd'
            }}
            placeholder='{"hello":"world"}'
            aria-label="JSON input"
          />
          {error && (
            <Text color="tomato" mt={2} fontFamily="Menlo, ui-monospace, monospace">{error}</Text>
          )}
        </Box>
        <Box width={["100%", 1/2]}>
          <Box
            as="textarea"
            value={pretty}
            onChange={(e) => setInput(e.target.value)}
            rows={20}
            sx={{
              width: '100%',
              fontFamily: 'Menlo, ui-monospace, monospace',
              fontSize: 1,
              backgroundColor: night ? '#121212' : '#fff',
              color: night ? '#f5f5f5' : '#222',
              borderColor: night ? '#333' : '#ddd'
            }}
            aria-label="Prettified JSON (editable)"
          />
          <Button mt={3} onClick={usePrettyAsEditable} sx={{ fontFamily: 'Menlo, ui-monospace, monospace' }}>
            Use prettified as input
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default JsonPrettifier;
